module.exports = __webpack_public_path__ + "img/speed.ee834f4d.svg";